import { Badge } from "react-bootstrap";
import { NOTIFICATION_STATUS, WASH_HISTORY_STATUS } from "utils/constants";

export const StatusBadge = ({ status, t }) => {
  const isActive = status === 1;

  return (
    <p className={`status_tag ${isActive ? "active" : "inactive"}`}>
      {t(isActive ? "Active" : "Inactive")}
    </p>
  );
};

export const CustomerStatusBadge = ({ status, t }) => {
  const statusMap = {
    1: { label: "Active", className: "active" },
    0: { label: "Blocked", className: "inactive" },
    2: { label: "Deleted", className: "deleted" },
  };

  const currentStatus = statusMap[status] || {
    label: "Unknown",
    className: "unknown",
  };

  return (
    <p className={`status_tag ${currentStatus.className}`}>
      {t(currentStatus.label)}
    </p>
  );
};

const USER_STATUS_CONFIG = {
  1: { label: "Active", className: "active" },
  0: { label: "Inactive", className: "inactive" },
  "-1": { label: "Invited", className: "info" },
};
const MPIN_STATUS_CONFIG = {
  true: { label: "Set", className: "active" },
  false: { label: "Not Set", className: "inactive" },
  null: { label: "Not available", className: "inactive" },
};

export const UserStatusBadge = ({ status, t }) => {
  const { label, className } = USER_STATUS_CONFIG[status] || {};

  return <p className={`status_tag ${className}`}>{t(label)}</p>;
};
export const MpinStatusBadge = ({ status, t }) => {
  
  const { label, className } = MPIN_STATUS_CONFIG[status] || {};

  return <p className={`status_tag ${className}`}>{t(label)}</p>;
};

const PAYMENT_STATUS_CONFIG = {
  0: { label: "Pending", className: "pending" },
  1: { label: "Paid", className: "active" },
  2: { label: "Refunded", className: "info" },
  3: { label: "Failed", className: "inactive" },
};

export const PaymentStatusBadge = ({ status, t }) => {
  const { label, className } = PAYMENT_STATUS_CONFIG[status] || {};

  return <p className={`status_tag ${className}`}>{t(label)}</p>;
};

const CUSTOMER_MEMBERSHIP_STATUS_CONFIG = {
  "-1": { label: "Deactive", className: "inactive" },
  0: { label: "Pending", className: "pending" },
  1: { label: "Active", className: "active" },
  2: { label: "Completed", className: "active" },
  3: { label: "Cancelled", className: "cancel" },
  4: { label: "Overridden", className: "overridden" },
  5: { label: "Transferred", className: "info" },
  6: { label: "Paused", className: "pending" },
  7: { label: "Hold", className: "inactive" },
};

export const CustomerMembershipStatusBadge = ({ status, t }) => {
  const { label, className } = CUSTOMER_MEMBERSHIP_STATUS_CONFIG[status] || {};

  return <p className={`status_tag ${className}`}>{t(label)}</p>;
};

export const WashHistoryStatusBadge = ({ status, t }) => {
  const { name, className } =
    WASH_HISTORY_STATUS?.find((option) => option?.value === status) || {};

  return <p className={`status_tag ${className}`}>{t(name)}</p>;
};

export const NotificationStatusBadge = ({ status, t }) => {
  const { name, className } =
    NOTIFICATION_STATUS?.find((option) => option?.value === status) || {};

  return <p className={`status_tag ${className}`}>{t(name)}</p>;
};

// DASHBOARD
// DUMMY
export const EntryStatus = ({ status, t }) => {
  const isActive = status === 1;

  return (
    <p className={`status_tag ${isActive ? "active" : "inactive"}`}>
      {t(isActive ? "ANPR" : "Manual")}
    </p>
  );
};

// DUMMY
const VEHICLE_CURRENT_STATUS_CONFIG = {
  1: { label: "Interior In-progress ", className: "pending" },
  2: { label: "Exterior In-progress ", className: "overridden" },
  3: { label: "Interior In-progress ", className: "pending" },
  4: { label: "Exit The Store", className: "active" },
};
export const VehicleCurrentStatus = ({ status, t }) => {
  const { label, className } = VEHICLE_CURRENT_STATUS_CONFIG[status] || {};
  return <p className={`status_tag ${className}`}>{t(label)}</p>;
};

// DUMMY
const CUSTOMER_DASHBOARD_EVENT_STATUS = {
  1: { label: "Purchased Membership ", className: "initiated" },
  2: { label: "Upgraded Membership ", className: "active" },
  3: { label: "Car Washed ", className: "overridden" },
};
export const CustomerDashboardEventStatus = ({ status, t }) => {
  const { label, className } = CUSTOMER_DASHBOARD_EVENT_STATUS[status] || {};
  return <p className={`status_tag ${className}`}>{t(label)}</p>;
};

// DUMMY
const CUSTOMER_DASHBOARD_TRANSACTION_STATUS = {
  1: { label: "Membership ", className: "initiated" },
  2: { label: "One Time ", className: "overridden" },
};
export const CustomerDashboardTransactionStatus = ({ status, t }) => {
  const { label, className } =
    CUSTOMER_DASHBOARD_TRANSACTION_STATUS[status] || {};
  return <p className={`status_tag ${className}`}>{t(label)}</p>;
};
export const ApiLogBadge = ({ status, extra = "", type = "", t }) => {
  const badgeKey = normalizeBadge(type, status, extra);

  const badgeTitle =
    extra !== ""
      ? extra === 1
        ? "Success"
        : "Failure"
      : typeof status === "number"
        ? status
        : status;

  return (
    <p className={`status_tag api_log_badge ${type} ${badgeKey}`}>
      {t(badgeTitle)}
    </p>
  );
};

const normalizeBadge = (type, status, extra) => {
  // Result based on 1 / 0
  if (extra !== "") {
    return extra === 1 ? "success" : "failure";
  }

  // HTTP status codes
  if (type === "result" && typeof status === "number") {
    if (status >= 200 && status < 300) return "success";
    if (status >= 400 && status < 500) return "client_error";
    if (status >= 500 || status < 200) return "server_error";
    return "unknown";
  }

  // HTTP methods (GET, POST etc.)
  if (type === "method") {
    return String(status).toLowerCase();
  }

  return String(status).toLowerCase();
};
